import React, { useRef, useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import CloseIcon from '@mui/icons-material/Close'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { closePopup } from '../../actions/uiActions'
import { updateChildPresentation } from '../../actions/presentationActions'
import { withRouter } from '../../actions/withRouterHook'
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import 'react-super-treeview/dist/style.css'

function SlideHistoryPopup(props) {
    let navigate = useNavigate()
    let [needsToLoad, setNeedsToLoad] = useState(true)
    let [toUpdate, setToUpdate] = useState([])
    let [presentationId, setPresentationId] = useState(0)
    let [hasUpdate, setHasUpdate] = useState(false)
    let [includedAccordion, setIncludedAccordion] = useState([])
    let [excludedAccordion, setExcludedAccordion] = useState([])
    let [deletedAccordion, setDeletedAccordion] = useState([])

    // trigger on component mount
    useEffect(() => {
        if (props.presentationSlideChanges.includedTags && presentationId === 0 && needsToLoad) {
            buildIncludedRegion(props.presentationSlideChanges, props.popupInfo.slides)
            buildDeletedRegion(props.presentationSlideChanges, props.popupInfo.slides)
            setPresentationId(props.popupInfo.presentationId)
            setHasUpdate(props.presentationSlideChanges.hasUpdate)
            setNeedsToLoad(false)
        }
    })

    if (needsToLoad) {
        return (
            <Dialog
                open={true}
                maxWidth={'md'}
                onClose={handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="slides-history"
            >
                <CloseIcon onClick={handleClick} className="closePoup" />
                <DialogContent>
                    <LoadingSpinner loadingMessage="Loading History..." />
                </DialogContent>
            </Dialog>
        )
    } else {
        return (
            <Dialog
                open={true}
                maxWidth={'md'}
                onClose={handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="slides-history"
            >
                <CloseIcon onClick={handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    Slide History
                </DialogTitle>
                <DialogContent>
                    <DialogContent id="alert-dialog-description">
                        <Typography variant="h6" gutterBottom component="div">Latest Included</Typography>
                        {includedAccordion.map((data) => {
                            return (
                                <Accordion key={`included-accordion-${data.tag}`}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography style={{ fontSize: 14, fontWeight: 400 }}>
                                            Slide Tag: {data.tag} <span className="upgrade-message">{data.upgradeMessage}</span>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className="slide-info">
                                        <div>Slide Description: {data.description}</div><br />
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Version Number</TableCell>
                                                        <TableCell align="center">Change Notes</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {data.notes.map((note, index) => {
                                                        return (
                                                            <TableRow key={`tag-${index}-version-${note.slideVersion}`}>
                                                                <TableCell>{note.slideVersion}</TableCell>
                                                                <TableCell align="center">{note.slideChangeDescription}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </AccordionDetails>
                                </Accordion>);
                        })}
                        {deletedAccordion.length > 0 && <Typography variant="h6" gutterBottom component="div">Deleted Slides</Typography>}
                        {deletedAccordion.map((data) => {
                            return (
                                <Accordion key={`deleted-accordion-${data.tag}`}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography style={{ fontSize: 14, fontWeight: 400 }}>
                                            Slide Tag: {data.tag} <span className="upgrade-message">{data.upgradeMessage}</span>
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className="slide-info">
                                        <div>Slide Description: {data.description}</div><br />
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Version Number</TableCell>
                                                        <TableCell align="center">Change Notes</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {data.notes.map((note, index) => {
                                                        return (
                                                            <TableRow key={`tag-${index}-version-${note.slideVersion}`}>
                                                                <TableCell>{note.slideVersion}</TableCell>
                                                                <TableCell align="center">{note.slideChangeDescription}</TableCell>
                                                            </TableRow>
                                                        )
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </AccordionDetails>
                                </Accordion>);
                        })
                        }
                        {renderUpdateButton(hasUpdate)}
                    </DialogContent>
                </DialogContent>
            </Dialog>
        )
    }

    //#region Button Click Handlers
    function handleClick(event) {
        event.preventDefault()
        props.closePopup()
    }
    function handleUpdatePresentation(event) {
        event.preventDefault()
        props.updateChildPresentation(presentationId, toUpdate)
        navigate('/presentations')
    }
    //#endregion

    //#region State Building Events
    function buildIncludedRegion(popupInfo, slides) {
        let toUpdate = []
        let includedAccordion = []

        popupInfo.includedTags.forEach((t) => {
            let slide = slides.find(n => n.slideTag === t.tag)
            let latestVersion = findLatestSlideVersionForChild(t.tag, popupInfo.childNotes)
            let latestParentVersion = findLatestSlideVersionForChild(t.tag, popupInfo.parentNotes)
            let incObj = { "tag": t.tag, "description": slide["slideDescription"], "upgradeMessage": "", "notes": findNotesForTagFromSlideId(t.xP3SlideId, popupInfo.childNotes) }

            if (latestVersion > 0 && latestParentVersion > 0) {
                let needsUpdate = (latestVersion !== latestParentVersion) ? true : false
                incObj["upgradeMessage"] = (latestVersion !== latestParentVersion) ? `Upgrade To Version ${latestParentVersion}` : ""

                if (needsUpdate) {
                    incObj["notes"] = findNotesForTag(t.tag, popupInfo.parentNotes)
                }

                if (latestVersion !== latestParentVersion) {
                    toUpdate.push(t.tag)
                }
            }

            includedAccordion.push(incObj)
        })
        
        setToUpdate(toUpdate)
        setIncludedAccordion(includedAccordion)
    }
    function buildDeletedRegion(popupInfo, slides) {
        let deletedAccordion = []
        popupInfo.deletedTags.forEach((t) => {
            let slide = slides.find(n => n.slideTag === t.tag)
            let incObj = { "tag": t.tag, "description": slide["slideDescription"], "upgradeMessage": "", "notes": findNotesForTagFromSlideId(t.xP3SlideId, popupInfo.childNotes) }
            deletedAccordion.push(incObj)
        })
        setDeletedAccordion(deletedAccordion)
    }
    function findNotesForTag(tag, notes) {
        let rtnVal = []

        notes.forEach(n => {
            if (n.slideTag === tag) rtnVal.push(n)
        })

        return rtnVal
    }
    function findNotesForTagFromSlideId(slide, notes) {
        let rtnVal = []

        notes.forEach(n => {
            if (n.xP3SlideID === slide) rtnVal.push(n)
        })

        return rtnVal
    }
    function findLatestSlideVersionForChild(tag, notes) {
        let rtnVal = 0

        notes.forEach((n) => {
            if (n.slideTag === tag && n.slideVersion > rtnVal) {
                rtnVal = n.slideVersion
            }
        })

        return rtnVal
    }
    //#endregion

    //#region Render Methods
    function renderUpdateButton(hasUpdate) {
        if (hasUpdate) {
            return (<div style={{ marginTop: 10 }}>
                <button className="btn" type="submit" onClick={handleUpdatePresentation} value="Submit" id="submit_btn">
                    Update
                </button>
            </div>)
        }
    }
    //#endregion
}

function mapStateToProps(state) {
    return {
        popupInfo: state.ui.popupInfo,
        currentUser: state.users.currentUser,
        userID: state.users.userID,
        presentationSlideChanges: state.presentations.present.presentationSlideChanges,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({
            closePopup,
            updateChildPresentation
        }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SlideHistoryPopup))